import { graphql, useStaticQuery } from "gatsby";
import { useCallback, useEffect, useState } from "react";
import { retrieveOneTrust } from "../utility/onetrust";

export const insertChannelsightScript = () => {
  const whereToBuyButtons = document.getElementsByClassName("cswidget");
  // Inserisci lo script solo se ci sono bottoni "cswidget"
  const channelsightScriptId = `channelsight-script-injected`;
  if (whereToBuyButtons.length && !document.getElementById(channelsightScriptId)) {
    //console.log("Appending Channelsight script");
    const channelsightScript = document.createElement("script");
    channelsightScript.id = channelsightScriptId;
    channelsightScript.setAttribute(
      "src",
      `https://cscoreproweustor.blob.core.windows.net/widget/scripts/cswidget.loader.js`
    );
    channelsightScript.setAttribute("async", "");
    channelsightScript.setAttribute("defer", "");
    document.head.appendChild(channelsightScript);
  }
};

export const removeChannelsightScript = () => {
  const csScript = document.getElementById(`channelsight-script-injected`);
  if (csScript) {
    //console.log("Removing Channelsight script");
    csScript.remove();
  }
  const csWidgetScript = document.getElementById(`cswidgetjs`);
  if (csWidgetScript) {
    csWidgetScript.remove();
  }
};

const GROUPS = ["C0003"];
const areCookiesEnabled = () =>
  window.OnetrustActiveGroups && GROUPS.some((item) => window.OnetrustActiveGroups.includes(item));

export const useChannelSight = (location) => {
  const { config } = useStaticQuery(graphql`
    {
      config: liferayGeneralConfiguration {
        wtbCookies
      }
    }
  `);

  const cookieCheck = config.wtbCookies?.[0] === "yes";

  const [insertScript, setInsertScript] = useState(!cookieCheck);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    const calcInsertScript = async () => {
      const onetrust = await retrieveOneTrust();
      setInsertScript(!cookieCheck || !onetrust || areCookiesEnabled());
    };
    calcInsertScript();
  }, [location, cookieCheck]);

  useEffect(() => {
    if (insertScript) {
      insertChannelsightScript();
    }
    return () => removeChannelsightScript();
  }, [location, insertScript]);

  const handleWTBClick = useCallback(() => {
    if (cookieCheck && window.OneTrust && !areCookiesEnabled()) {
      setShowAlert(true);
      window.OneTrust.OnConsentChanged(() => {
        setInsertScript(areCookiesEnabled());
        setShowAlert(!areCookiesEnabled());
      });
    } else {
      setInsertScript(true);
    }
  }, [cookieCheck]);

  return [showAlert, setShowAlert, handleWTBClick];
};
